import { Paper, TextField, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { tokens } from "../../../../../../../theme";

interface TermsAndConditionsSectionProps {
  onChange?: (value: string) => void;
  initialValue?: string;
}

export default function TermsAndConditionsSection({
  onChange,
  initialValue = "",
}: TermsAndConditionsSectionProps) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [value, setValue] = useState(initialValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
    onChange?.(e.target.value);
  };

  return (
    <Paper sx={{ borderRadius: "14px", p: 2.5, boxShadow: 0, mb: 2 }}>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: "15px",
          color: colors.primary[100],
          mb: 1.5,
        }}
      >
        Terms & Conditions
      </Typography>
      <TextField
        multiline
        minRows={4}
        fullWidth
        value={value}
        onChange={handleChange}
        placeholder="Enter terms and conditions..."
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            bgcolor: "background.paper",
            fontSize: "13px",
            color: colors.primary[100],
            lineHeight: 1.8,
            "& fieldset": { border: `1px solid ${colors.primary[800]}` },
            "&:hover fieldset": { borderColor: colors.primary[500] },
            "&.Mui-focused fieldset": {
              borderColor: colors.primary[400],
              borderWidth: 1,
            },
          },
        }}
      />
    </Paper>
  );
}
